import { Controller } from "@hotwired/stimulus"
import { readFavourites } from "../lib/favourites_store"

// Plan mode is built from the favourites kept on this device: when the page asks for them (the seed),
// load the day's walk with their ids.
export default class extends Controller {
  static targets = ["seed"]
  static values = { slug: String }

  seedTargetConnected(element) {
    const url = new URL(element.dataset.url, window.location.origin)
    url.searchParams.set("ids", readFavourites(this.slugValue).join(","))

    const frame = element.closest("turbo-frame")
    if (frame) frame.src = url.pathname + url.search
  }
}
